/**
 * @description image width 100%
 * @author wangfupeng
 */

import ImageWidthBaseClass from './WidthBase'

class ImageWidth100 extends ImageWidthBaseClass {
  readonly title = '100%' // 菜单标题

  readonly value = '100%' // css width 的值
}

export default ImageWidth100
